import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { Text, InternalGrid } from '@paygreen/paygreen-ui';
import { withTranslation } from 'react-i18next';
import IconByName from '../../../utils/IconByName';
import { getStatusColorProps, IsDesktop } from '../../../utils/tools';

/**
 * Component to display a status in color with an Icon
 * Used in offsets table
 */
const StatusDisplayTable = ({
    statusOptions,
    status,
    textSize,
    iconSize,
    i18TextBase,
    hasIcon,
    t,
    ...rest
}) => {
    if (!statusOptions.hasOwnProperty(status)) {
        throw new Error(`The status "${status}" is not supported`);
    }

    return (
        <InternalGrid
            alignItems="center"
            justifyContent="flex-end"
            flexWrap="nowrap"
            title={t(i18TextBase + '.' + status + '.title')}
            {...rest}
        >
            {hasIcon && (
                <IconByName
                    name={statusOptions[status].icon}
                    marginRight="sm"
                    iconSize={iconSize}
                    {...getStatusColorProps(statusOptions, status)}
                />
            )}

            <Text
                textSize={textSize}
                htmlTag="strong"
                {...getStatusColorProps(statusOptions, status)}
            >
                {!IsDesktop() &&
                hasIcon &&
                i18next.exists(i18TextBase + '.' + status + '.nameShort')
                    ? t(i18TextBase + '.' + status + '.nameShort')
                    : t(i18TextBase + '.' + status + '.name')}
            </Text>
        </InternalGrid>
    );
};

StatusDisplayTable.propTypes = {
    status: PropTypes.string.isRequired,
    statusOptions: PropTypes.object.isRequired,
    i18TextBase: PropTypes.string.isRequired,
    iconSize: PropTypes.string,
    textSize: PropTypes.string,
    hasicon: PropTypes.bool,
};

StatusDisplayTable.defaultProps = {
    iconSize: 'sm',
    textSize: 'xs',
    hasIcon: true,
};

export default withTranslation('common')(StatusDisplayTable);
